export const _en = {
    code: {
        label: "Code society"
    },
    name: {
        label: "Name society"
    },
    isDefaultOrganization: {
        label: "Is default organization"
    },
    contact: {
        label: "Contact"
    },
    email: {
        label: "Mail"
    },
    address: {
        label: "Address"
    },
    phoneNumber: {
        label: "Phone number"
    },
    divisionId: {
        label: "Division"
    }
};

export const _fr = {
    code: {
        label: "Code société"
    },
    name: {
        label: "Nom"
    },
    isDefaultOrganization: {
        label: "Est la société principale : Toutes les ressources non-externes seront rattachées à cette société"
    },
    contact: {
        label: "Contact"
    },
    email: {
        label: "Mail"
    },
    address: {
        label: "Adresse"
    },
    phoneNumber: {
        label: "Numéro de téléphone"
    },
    divisionId: {
        label: "Service"
    }
};